"use strict";

exports.__esModule = true;
exports.default = void 0;
var _createEscaper = _interopRequireDefault(require("./_createEscaper.js"));
var _unescapeMap = _interopRequireDefault(require("./_unescapeMap.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Function for unescaping strings from HTML interpolation.
var _default = exports.default = (0, _createEscaper.default)(_unescapeMap.default);